export function formatCurrency(amountCents: number): string {
  return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
    amountCents / 100
  );
}

export type KeyboardShortcut = {
  label: string
  shortcuts: ShortcutKey[]
}

export type ShortcutKey = {
  key: string
  alt?: boolean
  shift?: boolean
  meta?: boolean
  ctrl?: boolean
}

export function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
  const secs = (seconds % 60).toString().padStart(2, '0');
  return `${mins}:${secs}`;
}
